import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'

interface TopBarContextValue {
    filterContent: ReactNode | null
    setFilterContent: (content: ReactNode | null) => void
}

const TopBarContext = createContext<TopBarContextValue>({
    filterContent: null,
    setFilterContent: () => {},
})

export function TopBarProvider({ children }: { children: ReactNode }) {
    const [filterContent, setFilterContentState] = useState<ReactNode | null>(null)

    const setFilterContent = useCallback((content: ReactNode | null) => {
        setFilterContentState(content)
    }, [])

    return (
        <TopBarContext.Provider value={{ filterContent, setFilterContent }}>
            {children}
        </TopBarContext.Provider>
    )
}

export function useTopBar() {
    return useContext(TopBarContext)
}
